import React from 'react';
import classnames from 'classnames';
import { StatusBanner } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { IconTextDynamic } from 'web-ui-components/lib/molecules/icon-text-dynamic';

import { dismissLastLoginAlert } from '../../actions/LastLoginActionCreator';
import LastLoginStore from '../../stores/LastLoginStore';
import {
  PLATFORM_WEB,
  ICON_DICT_SMALL,
} from '../../constants/LastLoginConstants';

export const LastLoginAlert = () => {
  const { platformDetails, platformType, loginDate } =
    LastLoginStore.getDetails();

  return (
    <StatusBanner.Information
      onClose={dismissLastLoginAlert}
      data-test-id="last-login-alert-banner"
    >
      <IconTextDynamic
        iconType={ICON_DICT_SMALL[platformType]}
        iconSize="sm"
        layout="left"
        className={classnames('last-login-alert-banner__content', {
          'last-login-alert-banner__content--desktop':
            platformType === PLATFORM_WEB,
        })}
      >
        <StandardBody isFlush>
          <span>
            <b>Previous login: </b>
            {`${platformDetails}  |  ${loginDate}`}
          </span>
        </StandardBody>
      </IconTextDynamic>
    </StatusBanner.Information>
  );
};
